/**
 * TextImageBlock - Renders text content with an image
 *
 * Supports image on left or right side.
 * Text content supports basic markdown-like formatting.
 */

import DOMPurify from "dompurify";
import "./TextImageBlock.scss";

interface TextImageBlockProps {
    textContent?: string;
    imageUrl?: string;
    imagePosition?: "left" | "right";
}

export const TextImageBlock = ({
    textContent,
    imageUrl,
    imagePosition = "right",
}: TextImageBlockProps) => {
    if (!textContent && !imageUrl) return null;

    // Sanitize text content (allows basic HTML)
    const sanitizedText = textContent
        ? DOMPurify.sanitize(textContent)
        : "";

    return (
        <div className={`text-image-block text-image-block--image-${imagePosition}`}>
            <div className="text-image-block__inner">
                {textContent &&
                    <div
                        className="text-image-block__text"
                        dangerouslySetInnerHTML={{ __html: sanitizedText }}
                    />
                }
                {imageUrl &&
                    <div className="text-image-block__image-wrapper">
                        <img
                            src={imageUrl}
                            alt=""
                            className="text-image-block__image"
                        />
                    </div>
                }
            </div>
        </div>
    );
};
